import React from 'react';
import {makeStyles} from "@mui/styles";
import {useSelector} from "react-redux";
import {format, parse} from "date-fns";
import {Icon, Paper, SvgIcon} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {lightBlue} from "@mui/material/colors";
import {ReactComponent as Boat} from "../../../../svg/Blue/Boat.svg";
import {ReactComponent as Tent} from "../../../../svg/Blue/Tent.svg";
import {ReactComponent as DayAndNight} from "../../../../svg/Blue/Day-and-Night.svg";
import {ReactComponent as Calendar} from "../../../../svg/Blue/Calendar.svg";

const useStyles = makeStyles((theme) => ({
    section1: {
        margin: theme.spacing(3, 2),
    },
    bookingButton: {
        textAlign: 'center',
        backgroundColor: '#00b7f0',
        color: '#ffffff',
        '&:hover': {
            backgroundColor: '#11486e',
            color: '#ffffff',
        },
    },
    cancelButton: {
        textAlign: 'center',
        backgroundColor: '#f94b4b',
        color: '#ffffff',
        '&:hover': {
            backgroundColor: '#f30303',
            color: '#ffffff',
        },
    },
    moreInfoButton: {
        textAlign: 'center',
    },
    bookingText: {
        '& span': {
            fontSize: '1.8rem',
        }
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    summaryItems: {
        '&:last-child': {
            marginBottom: 24
        }
    }
}));
const TripDetails = () => {
    const {data: trip} = useSelector(state => state.trip);

    const classes = useStyles();

    const boardDate = parse(trip.boarddate, 'yyyy-MM-d', new Date());
    const returnDate = parse(trip.returndate, 'yyyy-MM-d', new Date());
    const tripDates = `${format(boardDate, 'MMM d')} - ${format(returnDate, 'MMM d')}, ${format(returnDate, 'yyyy')}`;

    const locationIcon = parseInt(trip['locationFk']) !== 7 ?
        <SvgIcon component={Boat} viewBox="0 0 50 50" sx={{
            stroke: '#000000',
            fill: '#000000',
            width: '35px',
            height: '30px',
            marginRight:'10px',
        }}/> : <SvgIcon component={Tent} viewBox="0 0 50 50" sx={{
            stroke: '#000000',
            fill: '#000000',
            width: '35px',
            height: '30px',
            marginRight:'10px',
        }}/>;
    const thumbNail = trip.tripImageCard || trip.trip_class_info?.headerImage;
    return (
        <Paper className={'tripSummary'} elevation={3}>
            <img src={thumbNail} alt={trip['shortcomment']} width={'100%'} className={'summaryImage'}/>
            <div className={classes.section1}>
                <Grid container alignItems="center">
                    <Grid item container spacing={3} justify="space-between" alignItems="flex-start"
                          direction="column" className={classes.summaryItems}>
                        <Grid item xs>
                            <Typography variant="h3" component="h4" className={'tripTitle'}>
                                {trip['shortcomment']}
                            </Typography>
                        </Grid>
                        <Grid item xs>
                            <Typography component="h3" variant="h4" align="left">
                                        <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.75rem'}}>
                                            <SvgIcon component={Calendar} viewBox="0 0 50 50" sx={{
                                                stroke:'#000000',
                                                fill:'#000000',
                                                width: '35px',
                                                height: '30px',
                                                marginRight:'10px',
                                            }}/> {tripDates}
                                        </span>
                            </Typography>
                        </Grid>
                        <Grid item xs>
                            <Typography component="h3" variant="h4" align="left">
                                        <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.75rem'}}>
                                            <SvgIcon component={DayAndNight} viewBox="0 0 50 50" sx={{
                                                stroke:'#000000',
                                                fill:'#000000',
                                                width: '35px',
                                                height: '30px',
                                                marginRight:'10px',
                                            }}/> {trip['length']} nights {parseInt(trip['length']) + 1} days
                                        </span>
                            </Typography>
                        </Grid>
                        <Grid item xs>
                            <Typography component="h3" variant="h4" align="left">
                                        <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.75rem'}}>
                                            {locationIcon} {trip['location']['location']}
                                        </span>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </Paper>
    );
};

export default TripDetails;
